var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.458,
    height: 23.593,
    viewBox: "0 0 22.458 23.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u0430\\u0441\\u0441\\u0430\\u0436\\u0438\\u0440",
    transform: "translate(0.481 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041F\\u0430\\u0441\\u0441\\u0430\\u0436\\u0438\\u0440-2",
    "data-name": "\\u041F\\u0430\\u0441\\u0441\\u0430\\u0436\\u0438\\u0440",
    d: "M181.453,330.166h17.918s1.7.142,1.661-1.131.071-3.11-2.05-4.524-4.665-2.792-4.665-2.792-.708-.247-.672-.848a4.046,4.046,0,0,1,.141-1.449c.177-.283.142-1.52.531-1.732s1.025,0,1.237-1.449-.177-1.661-.389-1.873.531-1.166.389-2.368a3.324,3.324,0,0,0-1.237-2.545c-.707-.459-1.379-1.909-3.57-1.873a5.189,5.189,0,0,0-4.7,2.9,5.7,5.7,0,0,0-.53,3.57c.07.353-.884.353-.742,1.025a4.747,4.747,0,0,0,.99,2.333c.565.495.247.707.459,1.2s.53.671.565,1.378.319,1.308-.565,1.732-4.065,1.979-5.337,3.464-1.449,2.4-1.272,3.64S181.453,330.166,181.453,330.166Z",
    transform: "translate(-179.557 -307.581)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M7.14,13.916l3.251,3.022,3.442-3.022",
    transform: "translate(0.175 0.222)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.bbde43e64d2b705c47b4ef5927254a3a.svg";
export { ForwardRef as ReactComponent };